module.exports = __webpack_public_path__ + "static/media/overlay_background.21ec9d0f.png";